import type { JSX } from 'react';
import { styled } from '@mui/material';
import { CircleXIcon } from 'lucide-react';
import CustomButton from '@/components/Common/Button';

const ClearButton = styled(CustomButton)({
  borderRadius: '0px',
  width: '100%',
  '& > .MuiBox-root': {
    justifyContent: 'space-between',
  },
});

interface IProps {
  isDisabled: boolean;
  clearFilters: () => void;
}

export default function ClearFiltersButton({
  isDisabled,
  clearFilters,
}: IProps): JSX.Element {
  const handleClick = (): void => clearFilters();

  return (
    <ClearButton
      onClick={handleClick}
      disabled={isDisabled}
      label="Clear all filters"
      endIcon={<CircleXIcon />}
    />
  );
}
